import { useCallback, useRef } from 'react';

type UseDebounce = {
  debounce: (callback: () => void | Promise<void>) => void;
  cancel: () => void;
};

const useDebounce = (timeout: number): UseDebounce => {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const debounce = useCallback(
    (callback: () => void | Promise<void>) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout((): void => {
        callback();
      }, timeout);
    },
    [timeout]
  );

  const cancel = useCallback((): void => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);

  return { debounce, cancel };
};

export { useDebounce };
